import React from 'react';
import PropTypes from 'prop-types';
import { numberFormatter } from '../../../../utils/number';

const BankReconciliationDiffCell = ({ value }) => (
  <span
    className={value > 0 ? 'text-danger font-weight-bold' : 'text-success'}
  >
    {numberFormatter({ value })}
  </span>
);

BankReconciliationDiffCell.propTypes = {
  value: PropTypes.number.isRequired,
};

export default BankReconciliationDiffCell;
